import { connect } from 'react-redux'

import {
  getComments,
  deleteComment,
  setComment,
} from 'reduxpath/ducks/Project/Comment'

import TabProjectDetails from './units'

const mapStateToProps = state => ({
  comments: state.ProjectComment.data,
  order: state.ProjectDetail.data,
})

const mapDispatchToProps = dispatch => ({
  handleWriteComment(e) {
    dispatch(setComment(e.target.value))
  },
  handleDeleteComment(commentId, orderId, currentShow) {
    return (e) => {
      e.preventDefault()
      dispatch(deleteComment(commentId, () => dispatch(getComments({
        limit: currentShow,
        sort: 'createdAt DESC',
        search: JSON.stringify({
          order: orderId,
        }),
      }))))
    }
  },
  handleLoadMore(currentShow, orderId) {
    return (e) => {
      e.preventDefault()
      dispatch(getComments({
        limit: currentShow + 5,
        sort: 'createdAt DESC',
        search: JSON.stringify({
          order: orderId,
        }),
      }))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TabProjectDetails)
